import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/24/outline';
import { GapRow } from '../utils/documentationGaps';

interface Props {
  rows: GapRow[];
  caseId: string;
  // Show "add" links into the case form. Off for roles that can't edit the case.
  canEdit: boolean;
  className?: string;
}

// Inline "Not documented" placeholder for expected fields a case has not filled. Absence is a
// finding in a human-rights case, so gaps are shown where the value would be, not hidden.
const NotDocumented: React.FC<Props> = ({ rows, caseId, canEdit, className }) => {
  if (rows.length === 0) return null;
  return (
    <div className={`rounded-md border border-dashed border-gray-300 dark:border-gray-600 px-3 py-2 text-sm ${className ?? 'mt-3'}`}>
      <span className="italic text-gray-500 dark:text-gray-400 mr-1">Not documented:</span>
      <span className="inline-flex flex-wrap gap-x-3 gap-y-1">
        {rows.map((r) => (
          <span key={r.key} className="inline-flex items-center gap-1 text-gray-700 dark:text-gray-300">
            {r.label}
            {canEdit && (
              <Link
                to={`/cases/${caseId}/edit?step=${r.step}&field=${encodeURIComponent(r.key)}`}
                title={`Add ${r.label.toLowerCase()} in the case form`}
                aria-label={`Add ${r.label.toLowerCase()}`}
                className="inline-flex items-center rounded-full p-0.5 text-emerald-600 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:bg-emerald-900/30"
              >
                <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" />
              </Link>
            )}
          </span>
        ))}
      </span>
    </div>
  );
};

export default NotDocumented;
